<script>
import App from '@/App.vue'
import '@/scss/style-light-dark.scss'

export default {
  name: 'AppDefault',
  render: h => h(App)
}
</script>
